import { useDataValue, useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'form',
    path: 'tags',
    viewPath: props.viewPath,
  })

  let tags = useDataValue({
    context: 'form',
    path: 'tags',
    viewPath: props.viewPath,
  })

  let tag = useDataValue({
    context: 'tag',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(tags.filter(({ id }) => id !== tag.id))
  }
}
